import React from 'react'
import PageTitle from '../../pages/page-title'
import { Icon } from 'react-bulma-components'
import { BillIcon, CalendarIcon, EmployerIcon, InterimAgencyIcon } from '../../icons'
import { UserIcon } from '@heroicons/react/outline'
import Avatar from '../../avatar/avatar'
import { localDate } from '../../../utils/date'
import Protected from '../../protected/protected'
import { PeriodSummary } from '../../../api/period-summaries'

interface PreBillingPageTitleProps {
  preBilling: PeriodSummary
  onInvoiceRefClick?(): void
  /** When false, invoice number actions are hidden (e.g. pre-billing not active). */
  invoiceActionsEnabled?: boolean
}

const PreBillingPageTitle: React.FC<PreBillingPageTitleProps> = ({
  preBilling,
  onInvoiceRefClick,
  invoiceActionsEnabled = true,
}) => {
  return (
    <PageTitle
      title={preBilling.identifier}
      subTitle={
        <>
          <Icon.Text mr={5}>
            <Icon mr={1}>
              <EmployerIcon />
            </Icon>
            {preBilling.employer.name}
          </Icon.Text>
          <Icon.Text mr={5}>
            <Icon mr={1}>
              <InterimAgencyIcon />
            </Icon>
            {preBilling.interimAgency.name}
          </Icon.Text>
          <Icon.Text mr={5}>
            <Icon mr={1}>
              <CalendarIcon />
            </Icon>
            {localDate(preBilling.createdAt)}
          </Icon.Text>
          <Icon.Text mr={5}>
            <Icon mr={1}>
              <UserIcon />
            </Icon>
            <Avatar user={preBilling.createdBy} />
          </Icon.Text>
          <Protected
            roles={[
              {
                role: 'employerMember',
                action: { resource: 'periodSummaries', name: 'create' },
              },
            ]}
          >
            {preBilling.invoiceRef && invoiceActionsEnabled && (
              <Icon.Text
                mr={5}
                renderAs="a"
                textColor="link"
                onClick={() => onInvoiceRefClick && onInvoiceRefClick()}
                data-tooltip="Numéro de facture renseigné"
                data-test="pre-billing-edit-invoice-ref-link"
              >
                <Icon mr={1}>
                  <BillIcon />
                </Icon>
                {preBilling.invoiceRef}
              </Icon.Text>
            )}
            {preBilling.invoiceRef && !invoiceActionsEnabled && (
              <Icon.Text
                mr={5}
                data-tooltip="Pré-facturation inactive — modification du numéro de facture désactivée"
              >
                <Icon mr={1}>
                  <BillIcon />
                </Icon>
                {preBilling.invoiceRef}
              </Icon.Text>
            )}
          </Protected>
        </>
      }
    />
  )
}

export default PreBillingPageTitle
